module.exports = __webpack_public_path__ + "2618e21f1cd5dcbd95d7b119f7b4e33a.svg";